
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'WarfarinDose',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/WarfarinDose.vue